import React from 'react'
import MiniSwapper from '../dashboard/MiniSwapper'

export default function Swap({signer}) {
  return (
    <MiniSwapper signer={signer} />
  )
}
